import { DateTime } from 'luxon';
import React from 'react';
import { useSelector } from 'react-redux';

import { COLOR_TAG_TEXT_ERROR_HOVER, FORMAT_DATE, HEIGHT_HEADER_ROW } from '../const';
import { RootState } from '../store';
import { useGantOperationalHeight } from './hook/useGantOperationalHeight';

interface IGantGridTodaySelected {
    typeGrid: 'header' | 'main';
}

const GantGridTodaySelected: React.FC<IGantGridTodaySelected> = ({ typeGrid }) => {
    const widthColumn = useSelector<RootState, number>((state) => state.gant.widthColumn);
    const startDateExtend = useSelector<RootState, string>((state) => state.gant.startDateExtend);

    const visibleHeight = useGantOperationalHeight();

    const offsetDays = DateTime.fromSQL(DateTime.now().toFormat(FORMAT_DATE)).diff(
        DateTime.fromSQL(startDateExtend),
        'days',
    ).days;

    const x1 = offsetDays * widthColumn;
    const x2 = x1 + widthColumn;

    const height = typeGrid === 'main' ? visibleHeight : HEIGHT_HEADER_ROW;

    return (
        <g style={{ pointerEvents: 'none', mixBlendMode: 'normal' }}>
            <rect x={x1} y={0} width={widthColumn} height={height} fill={COLOR_TAG_TEXT_ERROR_HOVER} opacity={0.05} />

            <line x1={x1} y1={0} x2={x1} y2={height} stroke={'red'} strokeWidth={1} />
            <line x1={x2} y1={0} x2={x2} y2={height} stroke={'red'} strokeWidth={1} />
        </g>
    );
};

export default React.memo(GantGridTodaySelected);
